export const environment = {
  production: true,
  wfVersion: '4.28.0',
  wfEnvironment: null,
  sentryDsn: 'https://12a091dbf2fd75e206d237001cb535ea@o4508754397167616.ingest.de.sentry.io/4509032536670288',
  sentryInstance: 'Region Stockholm',
  sentryEnvironment: 'PRODUCTION'
};
